import { render } from "./insight-tile.vue?vue&type=template&id=2c54ed6c"
import script from "./insight-tile.vue?vue&type=script&lang=js"
export * from "./insight-tile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__